import { Injectable } from '@angular/core';
import { User } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Observable } from 'rxjs';
import { UsersApi } from './api/users-api.service';

interface UserPageResult {
  items: User[];
  totalCount: number;
  filtered: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(
    private api: UsersApi,
    private fuseProgressBarService: FuseProgressBarService
  ) { }

  async loadData({ where, options }): Promise<UserPageResult> {
    this.fuseProgressBarService.show();

    return this.api
      .listUsers({
        orderBy: options.orderBy,
        limit: options.limit,
        offset: options.offset,
        where: where
      })
      .toPromise()
      .then((page) => {
        this.fuseProgressBarService.hide();

          return {
            items: page.items,
            totalCount: page.totalCount,
            filtered: Boolean(!!where.name_contains || where.archived !== false || !!where.email_contains || !!where.type_in || !!where.role_in)
          };
        });
  }

  save(id: string, input: any): Observable<any> {
    if (id) {
      return this.api.updateUser(id, input);
    }
    return this.api.createUser(input);
  }

  archivedUser(id: string): Observable<any> {
    return this.api.archiveUser(id);
  }

  unarchiveUser(id: string): Observable<any> {
    return this.api.unarchiveUser(id);
  }

  setUserPassword(id: string, input: { password: string, permanentPassword: boolean }): Observable<void> {
    return this.api.setUserPassword(id, input);
  }
}
